module.exports = __webpack_public_path__ + "img/resized-APP-0006-1.83927c3f.png";